import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
} from 'react';
import { useTranslation } from 'react-i18next';
import { FormTemplate, FormTemplateSection } from 'data/template/template.types';
import * as types from 'data/utimacoCircuitSwitch/utimacoCircuitSwitch.types';
import Form, {
  FieldUpdateHandlerParam,
} from 'shared/form';
import './utimaco-circuit-switch-form.scss';
import { FormLayout } from 'components/FormLayout';

type Props = {
  template: FormTemplate,
  data: Partial<types.UtimacoCircuitSwitch>
  i18nKeyPrefix?: string
  isEditing?: boolean,
  onFieldUpdate?: (param: FieldUpdateHandlerParam, formSection?: 'main') => void
}

export type Ref = {
  isValid: (forceValidation: boolean, forceTouched: boolean) => boolean
  getValues: () => types.UtimacoCircuitSwitch
}

export const COLLECTION_FUNCTION_GROUP_I18N_KEY = 'utimacoCircuitSwitch.form';

export const UtimacoCircuitSwitchForm = forwardRef<Ref, Props>(({
  template,
  data,
  i18nKeyPrefix = COLLECTION_FUNCTION_GROUP_I18N_KEY,
  onFieldUpdate = () => null,
}: Props, ref) => {
  const mainRef = useRef<Form>(null);

  const isValid = (forceValidation = false, forceTouched = true) => {
    const isMainValid = mainRef.current?.isValid(forceValidation, forceTouched) ?? true;
    return isMainValid;
  };

  const getValues = () => {
    const formValues: types.UtimacoCircuitSwitch = {
      ...mainRef.current?.getValues(),
    };

    return formValues;
  };

  useImperativeHandle(ref, () => ({
    isValid,
    getValues,
  }));

  const onMainFieldUpdate = (param: FieldUpdateHandlerParam) => onFieldUpdate(param, 'main');

  return (
    <div className="utimaco-packet-switch-form" data-testid="UtimacoCircuitSwitchForm">
      <div data-testid="UtimacoCircuitSwitchFormMain">
        <FormLayout>
          <Form
            ref={mainRef}
            name={template.formId ?? template.key}
            defaults={data}
            fields={(template.main as FormTemplateSection).fields}
            layout={(template.main as FormTemplateSection).metadata.layout?.rows}
            i18nKeyPrefix={i18nKeyPrefix}
            fieldUpdateHandler={onMainFieldUpdate}
          />
        </FormLayout>
      </div>
    </div>
  );
});

export default UtimacoCircuitSwitchForm;
